import React, { useEffect } from "react";
import styles from "./webApp.module.css";

const WebApp = ({ configID, setLoading }) => {
  useEffect(() => {
    setLoading(true);
  }, []);

  return (
    <div className={styles.webapp_container}>
      <iframe
        src={`${process.env.REACT_APP_WEB_APP_URL}/page/${configID}`}
        title="web-app-simulation"
        frameBorder="0"
        width="100%"
        height="100%"
        id="frame"
        onLoad={() => setLoading(false)}
        allow="microphone"
      />
    </div>
  );
};

export default WebApp;
